var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { "leave-active-class": _vm.transitionLeaveActiveClass } },
    [
      _c("owa-element-loading", {
        staticClass:
          "display-flex flex-column flex-items-center flex-content-center",
        attrs: {
          content: _vm.loadingMessage,
          "custom-style": {
            "min-height": "var(--element-md-loading-min-height)",
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }